import { useEffect, useState } from 'react';

import Modal, { Title } from '@components/Modal';

import { usePrintLabelBackOffice } from '@api/generatorNoFadcode';

import styles from './LabelPreview.module.scss';

export const LabelPreview = () => {
  const [imageData, setImageData] = useState<string | null>(null);

  const { mutateAsync } = usePrintLabelBackOffice();

  const handleCloseModal = () => {
    setImageData(null);
  };

  useEffect(() => {
    const labelBroadcastChannel = new BroadcastChannel('SimulatorLabelPrinter');

    labelBroadcastChannel.onmessage = async (event) => {
      try {
        const base64LabelImage = await mutateAsync({
          data: event.data,
        });
        setImageData(base64LabelImage);
      } catch (e) {
        console.error('Unable to fetch label image data');
      }
    };

    return () => {
      labelBroadcastChannel.close();
    };
  }, [mutateAsync]);

  if (!imageData) {
    return null;
  }

  return (
    <Modal testId="label-preview-modal">
      <Title title="Label preview" closeIcon onClick={handleCloseModal} />
      <div className={styles.previewWrapper}>
        <img
          className={styles.previewImage}
          alt="Label preview"
          src={`data:image/png;base64,${imageData}`}
        />
      </div>
    </Modal>
  );
};
